module.exports = __webpack_public_path__ + "static/img/rcharge.e53cba3c.jpg";